import {ssrLazy} from 'ssr/lazy';

export const GroupMapLazy = ssrLazy(() => import(/* webpackChunkName: "groupMap" */ '.'));
